import React, { useEffect, useState } from "react";
import Hero from "../Hero/Hero";
import Main from "../Main/Main";
// import './MainScreen.css';
import "../../../src/App.css";
import GamesImages from "../GamesImages/GamesImages";
import UpcomingEvents from "../UpcomingEvents/UpcomingEvents";
// import MainFooter from '../MainFooter/MainFooter';
import Footer from "../Footer/Footer";
import Header from "../header/Header";
import AuthPopup from "../AuthPopup/AuthPopup";
import ExposureHeader from "../ExposureHeader/ExposureHeader";
import Offcanvas from "react-bootstrap/Offcanvas";
import Empty from "../EmptyDiv/Empty";
import ScrollCasino from "../ScrollCasino/ScrollCasino";
import ScrollGames from "../ScrollGames/ScrollGames";
import News from "../News/news";
import DepositWithdraw from "../DepositWithdraw";
import Helper from "../../helper";
import HorseRacing from "../HorseRacing/HorseRacing";
import OfferBanner from "../OfferBanner/OfferBanner";
import { Carousel } from "antd";
import CarouselBanner from "../Carousal/CarouselBanner";
import GreyHoundRacing from "../GreyHoundRacing/GreyHoundRacing";
import ImageCarousel from "../ImageCaraousel/ImageCarousel";
import ResponsiveGif from "../responsivegif/ResponsiveGif";
import DepositeBonusBanner from "../DepositBonus/DepositBonusBanner";
import PartnerLogos from "../PartnerLogo/PartnerLogo";
import TopGamesSlider from "../TopGameSlider/TopGameSlider";
import { useLocation } from "react-router-dom";
import SideBarMenue from "../SideBarMenue/SideBarMenue";
import LiveMatchHeader from "../LiveMatchHeader/LiveMatchHeader";
import Appconfig from "../../config/config";
import axios from "axios";

const MainScreen = ({ footerTabs }) => {
  const userInfo = Helper();
  const location = useLocation();

  // FIX: Set "home" as the default value if location.state.myKey is not present.
  const myState = location.state?.myKey || "home";

  // State to control the header visibility
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
  const [eventType, setEventType] = useState(undefined);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 991);
  const [whatsappNum, setWhatsAppNumber] = useState("");

  const getWhatsAppNumber = () => {
    var data = JSON.stringify({
      site_code: Appconfig.sitecodes,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}numbers/getNumberBySiteCode`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {



          if (response.data.result) {
            // console.log("response", response.data?.resultData?.mob_num);

            setWhatsAppNumber(response.data?.resultData?.mob_num);
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        // postErrorToslack(error.message);
        console.log(error);
      });
  };
  useEffect(() => {
    getWhatsAppNumber();
  }, []);
  return (
    <div>
      {/* Ensure header is always visible and buttons inside it */}
      <div>{!userInfo && <News />}</div >
      <Header
        whatsappNum={whatsappNum}
      />
      <ScrollGames eventType={eventType} setEventType={setEventType} />
      <div className="main-content-wrapper">
        {/* <Hero text="SignUp now and get 50% bonus on your first deposit." speed={30} /> */}
        <div className="mainscreen-container">
          {/* <ExposureHeader /> */}
          {/* <GamesImages /> */}

          <div className="lg:pl-[18rem]">{userInfo && <DepositWithdraw />}</div>

          {myState === "inplay" && <LiveMatchHeader />}

          {/* This condition will now be true on direct load */}
          {myState === "home" && (
            <>
              {/* <CarouselBanner /> */}
              <Main />
              <OfferBanner />
              <ResponsiveGif />
              <TopGamesSlider />
            </>
          )}

          <UpcomingEvents eventType={eventType} />
          <HorseRacing />
          <GreyHoundRacing />
          <DepositeBonusBanner />
          <PartnerLogos />

          {/* <ScrollCasino /> */}
        </div>
      </div>
      {/* <MainFooter /> */}

      {/* AuthPopup should overlay on top and not interfere with other components */}
      {/* <AuthPopup show={isOffcanvasOpen} onHide={() => setIsOffcanvasOpen(false)} /> */}

      {/* Footer contains the button that controls offcanvas */}
      <Empty />
      <Footer setIsOffcanvasOpen={setIsOffcanvasOpen} />
    </div>
  );
};

export default MainScreen;